import React from 'react';
import './index.less.js';

var LeftSVG = function LeftSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 3001 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "973",
    id: "trapezoid-left-svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2659.584 1024H146.285714a146.285714 146.285714 0 0 1-146.285714-146.285714V146.285714a146.285714 146.285714 0 0 1 146.285714-146.285714h2855.058286l-341.76 1024z"
  }));
};

export { LeftSVG as default };
